export class RoleConst {
    public static SUPERADMIN = 'SUPERADMIN';
    public static MEADADMN = 'MEADADMN';
    public static STNSADMN = 'STNSADMN';
    public static MMTRNG = 'MMTRNG';
    public static MEADSIAM = 'MEADSIAM';
    public static STNMANAGER = 'STNMANAGER';
}